import React from 'react';

type LinkifiedTextProps = {
  text?: string | null;
  as?: React.ElementType;
  className?: string;
  style?: React.CSSProperties;
};

const createLinkifiedNodes = (text: string): React.ReactNode[] => {
  const nodes: React.ReactNode[] = [];
  const lines = text.split(/\r?\n/);

  lines.forEach((line, lineIdx) => {
    if (lineIdx > 0) {
      nodes.push(<br key={`br-${lineIdx}`} />);
    }

    const urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = urlRegex.exec(line)) !== null) {
      const url = match[0];
      const index = match.index;

      if (index > lastIndex) {
        nodes.push(line.slice(lastIndex, index));
      }

      let href = url;
      if (!/^https?:\/\//i.test(href)) {
        href = `https://${href}`;
      }

      nodes.push(
        <a
          key={`link-${lineIdx}-${index}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {url}
        </a>
      );

      lastIndex = index + url.length;
    }

    if (lastIndex < line.length) {
      nodes.push(line.slice(lastIndex));
    }

    if (line.length === 0) {
      nodes.push('');
    }
  });

  return nodes;
};

const LinkifiedText: React.FC<LinkifiedTextProps> = ({ text, as: Component = 'span', className, style }) => {
  const content = React.useMemo(() => (text ? createLinkifiedNodes(text) : []), [text]);

  return (
    <Component className={className} style={style}>
      {content}
    </Component>
  );
};

export default LinkifiedText;
